import { FC } from "react";
import {
  SliderInput,
  SliderTrack,
  SliderRange,
  SliderHandle,
  SliderMarker,
} from "@reach/slider";
import "@reach/slider/styles.css";
import "./styles.css";
import SliderMarkerLabel from "./SliderMarkerLabel";
import Unit from "../types/Unit";

interface SliderProps {
  onChange: (value: number) => void;
  min: number;
  max: number;
  step: number;
  value: number;
  unit?: Unit;
}

const Slider: FC<SliderProps> = ({
  onChange,
  min,
  max,
  step,
  value,
  unit = { single: "", plural: "" },
}) => {
  return (
    <SliderInput
      min={min}
      max={max}
      step={step}
      onChange={onChange}
      value={value}
      style={{ margin: "0px 3px 16px 3px" }}
    >
      <SliderTrack>
        <SliderRange />
        <SliderHandle
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        />
        <SliderMarker value={min}>
          <SliderMarkerLabel align="right" value={min} unit={unit} />
        </SliderMarker>
        <SliderMarker value={max}>
          <SliderMarkerLabel align="left" value={max} unit={unit} />
        </SliderMarker>
      </SliderTrack>
    </SliderInput>
  );
};

export default Slider;
